import { ICellRendererParams } from 'ag-grid-community'
import styled from 'styled-components'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import { colorPalette } from '../../../../style/colorPalette'
import { FontWeight } from '../../../../../styles/commonStyles'
import { useMemo } from 'react'

export const ProgressRateDiffCellRenderer = (
  params: ICellRendererParams<ProgressReportTableContent>
) => {
  const value = params.data?.progressRateDiff

  const progressRateDiff = useMemo<number | undefined>(
    () =>
      typeof value === 'string' ? parseFloat(value.replace('%', '')) : value,
    [value]
  )

  return <StyledCell progressRateDiff={progressRateDiff}>{value}</StyledCell>
}

const HIGHLIGHT_THRESHOLDS = {
  CRITICAL: -50,
  WARNING: -20,
} as const

const resolveTextColorByProgressRateDiff = (
  progressRateDiff?: number
): string | undefined => {
  if (typeof progressRateDiff !== 'number' || isNaN(progressRateDiff)) {
    return undefined
  }
  if (progressRateDiff < HIGHLIGHT_THRESHOLDS.CRITICAL) {
    return colorPalette.pink[5]
  }
  if (progressRateDiff < HIGHLIGHT_THRESHOLDS.WARNING) {
    return colorPalette.yellow[5]
  }
  return undefined
}

const StyledCell = styled('div')<{ progressRateDiff?: number }>(({
  progressRateDiff,
}) => {
  const color = resolveTextColorByProgressRateDiff(progressRateDiff)

  return {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontWeight: FontWeight.BOLD,
    fontSize: '13px',
    ...(color ? { color } : {}),
    overflow: 'hidden',
    padding: '0 6px',
  }
})
